import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const referralMissionAddEditRBAC = {
  pageID: '5f7c83c101b2ce21744cd082a92e2f18',
  elementID: {
    ViewPage: '723474204c912b45f1c2c6dde5b2460e',
    SaveMission: 'ed0a51c221329c694be99eb8fd27b2c2',
  },
} as const

export const useRBACReferralMissionAddEditPage = createUseRBAC(referralMissionAddEditRBAC.elementID)

export type UseRBACReferralMissionAddEditPageType = ReturnType<
  typeof useRBACReferralMissionAddEditPage
>
